import { merge } from "lodash.merge";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

const getInitialState = () => ({
  metadata: {
    isInitialized: false,
  },
  proposal: {},
});

export const useSidebarStore = createWithEqualityFn(
  devtools(
    persist(
      (set, get) => ({
        data: getInitialState(),

        actions: {
          resetSidebarStore: () => {
            set((s) => ({
              data: {
                ...getInitialState(),
              },
            }));
          },
          setSidebarProposalDetails: ({ proposalDetails = {}, pageMode }) => {
            if (Object.keys(proposalDetails).length === 0) {
              return;
            }

            const proposal = proposalDetails; //! implement transform function
            proposal.pageMode = pageMode;
            const submittedDate = proposal.submittedDate;
            if (submittedDate && submittedDate.constructor === Array) {
              const convertedDate = new Date(
                submittedDate[0],
                submittedDate[1],
                submittedDate[2]
              );
              proposal.dateCreated = convertedDate;
            } else {
              proposal.dateCreated = submittedDate;
            }

            set((s) => ({
              data: {
                ...s.data,
                metadata: {
                  isInitialized: true,
                },
                proposal,
              },
            }));
          },
        },
      }),
      {
        name: "sidebar-store",
        storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used,
        merge: (persistedState, currentState) =>
          merge(persistedState, currentState),
      }
    )
  )
);
